var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback } from 'react';
import toast from 'react-hot-toast';
import { useQueryClient } from '@tanstack/react-query';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import { exportInspectionAssistantReviewPath } from '@routes';
const namespace = 'features.ai_to_review_inspections.bulk_actions';
function ExportButton({ inspectionIds, disabled, queryParams, onExportSuccess }) {
    const queryClient = useQueryClient();
    const handleExport = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const url = exportInspectionAssistantReviewPath();
        let params;
        if (inspectionIds) {
            const param = new URLSearchParams();
            inspectionIds.split(',').forEach((id) => param.append('ids[]', id.trim()));
            params = param.toString();
        }
        else {
            params = queryParams;
        }
        const fullUrl = params ? `${url}?${params}` : url;
        try {
            const response = yield fetch(fullUrl, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error('Export failed');
            }
            const data = yield response.json();
            if (data.success) {
                void queryClient.invalidateQueries({ queryKey: ['ai-review-inspections'] });
                onExportSuccess === null || onExportSuccess === void 0 ? void 0 : onExportSuccess();
                toast.success(data.message);
            }
            else {
                toast.error(data.error || 'Export failed. Please try again.');
            }
        }
        catch (error) {
            toast.error('Export failed. Please try again.');
        }
    }), [inspectionIds, queryParams, queryClient, onExportSuccess]);
    return (React.createElement(Button, { tabIndex: 0, disabled: disabled, onClick: handleExport },
        React.createElement("i", { className: "fa-light fa-file-export" }),
        translate('export', { namespace })));
}
export default ExportButton;
